import { UIComponent } from "../components";
import { isAiAccessAllowed, isSubscriptionGateEnabled } from "../utils/aiAccess";

export class BtnAiTemplates extends UIComponent {
    init() {
        this.includeComponents({
            modalAiTemplates: "document@#modalAiTemplates",
            subscriptionModal: "document@#SubscriptionModal",
        });

        this.on("click", this.showPopup.bind(this));
    }

    showPopup() {
        if (!isAiAccessAllowed() && isSubscriptionGateEnabled()) {
            if (this.subscriptionModal?.element?.dataset) {
                this.subscriptionModal.element.dataset.titleMode = "ai";
            }
            this.subscriptionModal?.show();
            return;
        }
        this.modalAiTemplates.show();
    }
}
